
import { NavLink, useParams } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Shield,
  // LifeBuoy, 
  Settings,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from '../../../../../TranslationContext';

const SidebarRoles = () => {
  const { t } = useTranslation();
  const { appId } = useParams<{ appId: string }>();
  const [collapsed, setCollapsed] = useState(false);

  const navigation = [
    { name: t('nav_dashboard'), path: '/EntrepriseDashboard', icon: LayoutDashboard },
    { name: t('nav_users'), path: `/application/${appId}/Users`, icon: Users },
    { name: t('nav_roles'), path: `/application/${appId}/Roles`, icon: Shield },
    // { name: t('nav_support'), path: '/Support', icon: LifeBuoy },
    { name: t('nav_settings'), path: `/application/${appId}/SettingApp`, icon: Settings },
  ];

  return (
    <div className={`h-full bg-white border-r border-gray-200 flex flex-col ${collapsed ? 'w-20' : 'w-64'} transition-all duration-300`}>
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        {!collapsed && <h1 className="text-1xl font-bold text-gray-600 uppercase tracking-wider border-l-4 border-blue-600 pl-2 mb-4">{t('app_secure_by_otenti')}</h1>}
        <button 
          onClick={() => setCollapsed(!collapsed)}
          className="text-gray-500 hover:text-gray-700"
          aria-label={collapsed ? t('expand_sidebar') : t('collapse_sidebar')}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>
      
      <nav className="flex-1 p-2 overflow-y-auto">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center rounded-md p-3 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-indigo-50 text-indigo-600'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
          >
            <item.icon className="h-5 w-5 flex-shrink-0" />
            {!collapsed && <span className="ml-3">{item.name}</span>}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default SidebarRoles;
// import { NavLink, useParams } from 'react-router-dom';
// import { 
//   LayoutDashboard, 
//   Users, 
//   Shield,
//   LifeBuoy, 
//   Settings,
//   ChevronLeft,
//   ChevronRight
// } from 'lucide-react';
// import { useState } from 'react';


// const SidebarRoles = () => {
//   const { appId } = useParams<{ appId: string }>();
//   const [collapsed, setCollapsed] = useState(false);

//   const navigation = [
//     { name: 'Dashboard', path: '/EntrepriseDashboard', icon: LayoutDashboard },
//     { name: 'Users', path: `/application/${appId}/Users`, icon: Users },
//     { name: 'Rôles', path: `/application/${appId}/Roles`, icon: Shield },
//     { name: 'Support', path: '/Support', icon: LifeBuoy },
//     { name: 'Setting', path: `/application/${appId}/SettingApp`, icon: Settings },
//   ];

//   return (
//     <div className={`h-full bg-white border-r border-gray-200 flex flex-col ${collapsed ? 'w-20' : 'w-64'} transition-all duration-300`}>
//       <div className="p-4 border-b border-gray-200 flex items-center justify-between">
//         {!collapsed && <h1 className="text-1xl font-bold text-gray-600 uppercase tracking-wider border-l-4 border-blue-600 pl-2 mb-4">App secure by Otenti</h1>}
//         <button 
//           onClick={() => setCollapsed(!collapsed)}
//           className="text-gray-500 hover:text-gray-700"
//         >
//           {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
//         </button>
//       </div>
      
//       <nav className="flex-1 p-2 overflow-y-auto">
//         {navigation.map((item) => (
//           <NavLink
//             key={item.name}
//             to={item.path}
//             className={({ isActive }) =>
//               `flex items-center rounded-md p-3 text-sm font-medium transition-colors ${
//                 isActive
//                   ? 'bg-indigo-50 text-indigo-600'
//                   : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
//               }`
//             }
//           >
//             <item.icon className="h-5 w-5 flex-shrink-0" />
//             {!collapsed && <span className="ml-3">{item.name}</span>}
//           </NavLink>
//         ))}
//       </nav>
//     </div>
//   );
// };

// export default SidebarRoles;

